
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { Form } from '@/components/ui/form';
import { TimeSlotFormData } from './timeSlotFormSchema';
import DaySelectionField from './DaySelectionField';
import WorkoutTypeSelectionField from './WorkoutTypeSelectionField';
import TimeSelectionFields from './TimeSelectionFields';
import MaxClientsField from './MaxClientsField';
import RecurringModeField from './RecurringModeField';
import RecurringSettingsFields from './RecurringSettingsFields';

interface TimeSlotCreateFormContentProps {
  form: UseFormReturn<TimeSlotFormData>;
  onSubmit: (data: TimeSlotFormData) => Promise<void>;
  isSubmitting: boolean;
  isRecurringMode: boolean;
  children: React.ReactNode;
}

const TimeSlotCreateFormContent: React.FC<TimeSlotCreateFormContentProps> = ({
  form,
  onSubmit,
  isSubmitting,
  isRecurringMode,
  children,
}) => {
  return (
    <Form {...form}>
      <form
        onSubmit={form.handleSubmit(onSubmit)}
        className="space-y-4 h-full flex flex-col"
      >
        <div className="flex-1 overflow-y-auto space-y-4">
          <DaySelectionField control={form.control} />

          <WorkoutTypeSelectionField control={form.control} />

          <RecurringModeField control={form.control} />

          {isRecurringMode ? (
            <RecurringSettingsFields control={form.control} />
          ) : (
            <TimeSelectionFields
              control={form.control}
              watch={form.watch}
              setValue={form.setValue}
            />
          )}

          <MaxClientsField control={form.control} />
        </div>

        {children}
      </form>
    </Form>
  );
};

export default TimeSlotCreateFormContent;
